import { Link, useLocation } from 'react-router-dom';

const Menu = () => {
  const { pathname } = useLocation();

  return (
    <div className="policy-sidebar">
      <Link
        to="/privacy-policy"
        className={pathname === '/privacy-policy' ? 'active' : ''}
      >
        Privacy Policy
      </Link>
      <Link
        to="/terms-of-use"
        className={pathname === '/terms-of-use' ? 'active' : ''}
      >
        Terms of Use
      </Link>
    </div>
  );
};

export default Menu;
